import { Reveal } from "./Reveal";
import SectionLabel from "./SectionLabel";

const PROJECTS = [
    { id: "war-and-peace", title: "War & Peace", origin: "An India–Malaysia co-production." },
    { id: "amor", title: "AMOR", origin: "An India–South Korea co-production." },
];

const CORNERS = [
    "left-0 top-0 border-l border-t",
    "right-0 top-0 border-r border-t",
    "bottom-0 left-0 border-b border-l",
    "bottom-0 right-0 border-b border-r",
];

export default function InDevelopment() {
    return (
        <section
            id="development"
            data-testid="development-section"
            className="scroll-mt-20 px-6 py-28 sm:py-36"
        >
            <div className="mx-auto max-w-5xl">
                <SectionLabel id="development">In Development</SectionLabel>
                <div className="mt-14 grid gap-6 md:grid-cols-2">
                    {PROJECTS.map((p, i) => (
                        <Reveal key={p.id} delay={i * 0.12}>
                            <div
                                data-testid={`development-card-${p.id}`}
                                className="card-lift relative h-full border border-gold/25 px-8 py-14 text-center hover:border-gold/50 sm:px-12"
                            >
                                {CORNERS.map((pos) => (
                                    <span
                                        key={pos}
                                        aria-hidden="true"
                                        className={`absolute h-5 w-5 border-gold/70 ${pos}`}
                                    />
                                ))}
                                <h3
                                    data-testid={`development-title-${p.id}`}
                                    className="font-display text-4xl font-light leading-none text-cream sm:text-5xl"
                                >
                                    {p.title}
                                </h3>
                                <p className="mt-6 font-display text-lg font-light leading-snug text-cream/75">
                                    {p.origin}
                                </p>
                                <p className="mt-5 font-label text-[9px] uppercase tracking-[0.42em] text-gold/80">
                                    More details to be announced soon
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
